import {Component, ElementRef, HostListener} from '@angular/core';
import {NavBaseComponent} from '../nav-base/nav-base.component';

@Component({
  selector: 'app-nav-extras',
  templateUrl: './nav-extras.component.html',
  styleUrls: ['../nav-base/nav-base.component.scss','./nav-extras.component.scss']
})
export class NavExtrasComponent extends NavBaseComponent {
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if ( !this.eRef.nativeElement.contains(event.target)) {
      this.hideApps();
    }
  }
  showList: boolean = false;

  constructor(private eRef: ElementRef) {
    super()
  }

  toggleShowList() {
    this.showList = !this.showList;
  }

  hideApps() {
    setTimeout(()=>{
      this.showList = false;
    }, 300);
  }
}
